import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Tooltip } from "react-tooltip";
import { Image } from "hesus-ui-kit";
import searchIcon from "@icons/ic-search-blue.svg";
import ViewZone from "../ViewZone/ViewZone";
import AddEditCenterProductPrice from "../../../AddEditCenterProductPrice/AddEditCenterProductPrice";
import {
  DivBackgroundLowOpacity,
  DivBackgroundFullOpacity,
  DivToolTip,
} from "@utils/extra-style";
import "../../PriceList.scss";

const CatchmentArea = (props) => {
  const {
    t,
    data,
    centerProductStatus,
    updateRefeshStatus,
    transportTypes,
    companyId,
    centerId,
    centerProductId,
    countryId,
  } = props;
  const tooltipId = `department-tooltip-${data.id}`;
  const tooltipAnchor = `#department-tooltip-${data.id}`;
  const countText = data?.count > 0 ? "..." : "";

  const [viewZoneInfo, setViewZoneInfo] = useState(false);
  const [
    isEditCenterProductPricePopupVisible,
    setIsEditCenterProductPricePopupVisible,
  ] = useState(false);

  const viewZonePopUp = () => {
    setViewZoneInfo(!viewZoneInfo);
  };

  const closeZonePopUp = () => {
    setViewZoneInfo(!viewZoneInfo);
  };

  const editPrice = () => {
    setIsEditCenterProductPricePopupVisible(true);
    closeZonePopUp();
  };

  const closePriceEditPopup = () => {
    setIsEditCenterProductPricePopupVisible(false);
  };

  return (
    <>
      {data.isActive == 1 && (
        <DivBackgroundFullOpacity>
          {data.catchmentType === 0 && <span>{t("NONE")}</span>}
          {data.catchmentType === 1 && (
            <span>
              {t("CATCHMENT_AREA_RADIUS")} : {data.catchmentValue}{" "}
              {t("GENERAL_UNIT_KM")}
            </span>
          )}
          {data.catchmentType === 2 && (
            <>
              <span id={tooltipId}>
                {t("CATCHMENT_AREA_DEPARTMENTS")} : {data.sdepartment}{" "}
                {countText}
              </span>
              <Tooltip
                anchorSelect={tooltipAnchor}
                style={DivToolTip}
                content={data.departmenList}
              />
            </>
          )}
          {data.catchmentType === 3 && (
            <>
              <Image
                src={searchIcon}
                onClick={() => viewZonePopUp()}
                className="center-product-price-list__image-icon"
              />{" "}
              {t("CATCHMENT_AREA_ZONE")}
            </>
          )}
          {!(data.catchmentType in [0, 1, 2, 3]) && <span>{t("NONE")}</span>}
        </DivBackgroundFullOpacity>
      )}
      {data.isActive == 0 && (
        <DivBackgroundLowOpacity>
          {data.catchmentType === 0 && <span>{t("NONE")}</span>}
          {data.catchmentType === 1 && (
            <span>
              {t("CATCHMENT_AREA_RADIUS")} : {data.catchmentValue}{" "}
              {t("GENERAL_UNIT_KM")}
            </span>
          )}
          {data.catchmentType === 2 && (
            <>
              <span id={tooltipId}>
                {t("CATCHMENT_AREA_DEPARTMENTS")} : {data.sdepartment}{" "}
                {countText}
              </span>
              <Tooltip
                anchorSelect={tooltipAnchor}
                style={DivToolTip}
                content={data.departmenList}
              />
            </>
          )}
          {data.catchmentType === 3 && (
            <>
              <Image
                src={searchIcon}
                onClick={() => viewZonePopUp()}
                className="center-product-price-list__image-icon"
              />
              {t("CATCHMENT_AREA_ZONE")}
            </>
          )}
          {!(data.catchmentType in [0, 1, 2, 3]) && <span>{t("NONE")}</span>}
        </DivBackgroundLowOpacity>
      )}
      {viewZoneInfo && (
        <ViewZone
          data={data}
          closeZonePopUp={closeZonePopUp}
          centerProductStatus={centerProductStatus}
          editPrice={editPrice}
        />
      )}
      {isEditCenterProductPricePopupVisible && (
        <AddEditCenterProductPrice
          id={data.id}
          title={t("EDIT_PRICE")}
          onClose={closePriceEditPopup}
          actionType="edit"
          updateRefeshStatus={updateRefeshStatus}
          transportTypes={transportTypes}
          companyId={companyId}
          centerId={centerId}
          centerProductId={centerProductId}
          countryId={countryId}
        />
      )}
    </>
  );
};

CatchmentArea.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CatchmentArea);
